<template>
	<table id="wrapper" :style="wrapperHeight">
		<tr :style="setHeight">
			<td>
        <br /><br />
        <h5><slot name="empty_state_text"></slot></h5>
			</td>
		</tr>
	</table>
</template>

<script>
export default {
  props: ['height'],
  data () {
    return {
      wrapperHeight: 'height: calc(100vh - 54px);'
    }
  },
  mounted () {
    this.setHeight()
  },
  methods: {
    setHeight: function () {
      if (this.height > 0) this.wrapperHeight = 'height:' + this.height + 'px'
    }
  }
}
</script>
<style scoped>
  @import 'https://cdn.jsdelivr.net/npm/animate.css@3.5.2/animate.min.css';
  h5 {
    text-transform: uppercase;
    letter-spacing: 2px;
    font-size: 0.89rem;
    font-weight: 500;
  }
  #wrapper {
    width: 100%;
    margin: 0;
    padding: 0;
    border: 0;
  }
  #wrapper td {
    vertical-align: middle;
    text-align: center;
  }
</style>
